import dhtmlXCellObject from '../dhtmlXLayoutObject/dhtmlXCellObject';

class dhtmlXTabBarCell extends dhtmlXCellObject {
    constructor(g, e) {
        super();
        dhtmlXCellObject.apply(this, [g, "_tabbar"]);
        this.tabbar = e;
        this.conf.skin = this.tabbar.conf.skin;
        this.conf.tabbar_funcs = {
            show: "_showTab",
            hide: "_hideTab",
            isVisible: "_isTabVisible",
            enable: "_enableTab",
            disable: "_disableTab",
            isEnabled: "_isTabEnabled",
            getIndex: "_getIndex",
            getText: "_getTabText",
            setText: "_setTabText",
            setActive: "_setTabActive",
            isActive: "_isTabActive",
            close: "_removeTab"
        };

        for (var c in this.conf.tabbar_funcs) {
            // @ts-ignore
            if (typeof this[c] != "function") {
                // @ts-ignore
                this[c] = this._tabbarCall(this.conf.tabbar_funcs[c]);
            }
        }
        this.attachEvent("_onCellUnload", function () {
            // @ts-ignore
            this.tabbar = null;
            // @ts-ignore
            for (var h in this.conf.tabbar_funcs) {
                // @ts-ignore
                this[h] = null;
                // @ts-ignore
                this.conf.tabbar_funcs[h] = null;
            }
            // @ts-ignore
            this.conf.tabbar_funcs = null;
        });
        this.attachEvent("_onContentLoaded", function () {
            // @ts-ignore
            this.tabbar._callMainEvent("onContentLoaded", arguments);
            // @ts-ignore
            this.tabbar._callMainEvent("onTabContentLoaded", arguments);
        });
        this.attachEvent("_onContentAttach", function () {
            // @ts-ignore
            this.tabbar._adjustCell(this.tabbar.conf.lastActive);
        });
        this.attachEvent("_onBeforeContentAttach", function (a) {
            // @ts-ignore
            if (a == "sidebar" && this.conf.skin != "dhx_skyblue") {
                // @ts-ignore
                this._hideBorders();
            }
        });
    }

    _tabbarCall(a) {
        return function () {
            // @ts-ignore
            var h = [this._idd];
            for (var l = 0; l < arguments.length; l++) {
                h.push(arguments[l]);
            }
            // @ts-ignore
            return this.tabbar[a].apply(this.tabbar, h);
        };
    }
}


dhtmlXCellObject.prototype.attachTabbar = function (a) {
    this.callEvent("_onBeforeContentAttach", ["tabbar"]);
    if (typeof a == "string") {
        a = {mode: a};
    } else {
        if (typeof a != "object" || a == null) {
            a = {};
        }
    }
    var c = document.createElement("DIV");
    c.style.width = "100%";
    c.style.height = "100%";
    c.style.position = "relative";
    c.style.overflow = "hidden";
    if (typeof window.dhtmlXTabBarCell == "function" &&
        this instanceof window.dhtmlXTabBarCell) {
        if (this.conf.skin == "dhx_skyblue") {
            c._ofs = {t: -1, r: -1, b: -1, l: -1};
        }
        if (this.conf.skin == "material") {
            c._ofs = {t: 8, r: 8, b: 8, l: 8};
        }
    }
    this._attachObject(c);
    a.skin = this.conf.skin;
    a.parent = c;
    this.dataType = "tabbar";
    this.dataObj = new dhtmlXTabBar(a);
    a.parent = c = null;
    a = null;
    this.callEvent("_onContentAttach", []);
    return this.dataObj;
};

export default dhtmlXTabBarCell;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTabBar/dhtmlXTabBarCell.js